import { configureStore } from "@reduxjs/toolkit";

import alertSlice from "./slices/alertSlice";
import authSlice from "./slices/authSlice";
import agentsSlice from "./slices/agents.slice";
import usersSlice from "./slices/users.slice";
import customersSlice from "./slices/customers.slice";
import scheduleFineSlice from "./slices/scheduleFine.slice";
import transactionsSlice from "./slices/transactions.slice";
import balanceHistorySlice from "./slices/balanceHistory.slice";
import dashboardSlice from "./slices/dashboard.slice";
import imposedFinesSlice from "./slices/imposedFines.slice";
import reportsSlice from "./slices/reports.slice";
import vehicleBlacklistSlice from "./slices/vehicleBlacklist.slice";
import vehicleWarningsSlice from "./slices/vehicleWarnings.slice";

export const store = configureStore({
  reducer: {
    alert: alertSlice,
    auth: authSlice,
    agents: agentsSlice,
    users: usersSlice,
    customers: customersSlice,
    scheduleFine: scheduleFineSlice,
    transactions: transactionsSlice,
    balanceHistory: balanceHistorySlice,
    dashboard: dashboardSlice,
    imposedFines: imposedFinesSlice,
    reports: reportsSlice,
    vehicleBlacklist: vehicleBlacklistSlice,
    vehicleWarnings: vehicleWarningsSlice,
  },
});

export type RootState = ReturnType<typeof store.getState>;
export type AppDispatch = typeof store.dispatch;
